import React from 'react'
import PropTypes from 'prop-types'
import StepperActionBar from '../StepperActionBar'
import { SectionWrapper, ErrorMessage, ActionBarWrapper } from '../common'
import { injectProps } from 'helpers/utils'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'

const DateTimeSelector = ({
  children,
  currentStepIndex,
  error,
  submitFailed,
  onPrevPage,
  handleSubmit,
  appointmentDetailsResponseVO,
  isLoading
}) =>
  <form onSubmit={ handleSubmit }>
    <SectionWrapper>
      <UpdatingBlock condition={ isLoading }>
        { injectProps(children, { appointmentDetailsResponseVO }) }
      </UpdatingBlock>
      <ActionBarWrapper>
        <StepperActionBar
          hasPrevPage
          hasNextPage
          isPrevPageVisible
          currentStepIndex={ currentStepIndex }
          prevPageClick={ onPrevPage } />

        <ErrorMessage
          role="alert"
          aria-live="assertive"
          aria-label={ error }>
          { (submitFailed && error) || '' }
        </ErrorMessage>
      </ActionBarWrapper>
    </SectionWrapper>
  </form>

export default DateTimeSelector

DateTimeSelector.propTypes = {
  appointmentDetailsResponseVO: PropTypes.shape(),
  children: PropTypes.node,
  currentStepIndex: PropTypes.number,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  onPrevPage: PropTypes.func,
  submitFailed: PropTypes.bool
}
